import { Component, Input, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'ui-countdown-overlay',
    templateUrl: 'ui-countdown-overlay.html',
    styleUrls: ['ui-countdown-overlay.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiCountdownOverlay implements OnDestroy {
    @Input() countdown: number = -1; // -1: oculto, 0: tiempo agotado, >0: segundos restantes
    
    private _animationClass: string = '';

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnDestroy() {
    }

    get showCountdown(): boolean {
        // Mostrar contador cuando quedan 5 segundos o menos, o cuando el tiempo se agotó (0)
        return (this.countdown > 0 && this.countdown <= 5) || this.countdown === 0;
    }

    get countdownValue(): number {
        return this.countdown;
    }

    get animationClass(): string {
        if (this.countdown > 0) {
            return 'pulse';
        }
        return '';
    }
}

